import React from "react";

import { faArrowLeft, faWavePulse } from "@fortawesome/pro-regular-svg-icons";
import { Link } from "react-router-dom";

import { Pill } from "src/base-components/Pill";
import { Icon } from "src/design-system/Icon";
import { VersionPickerDisplay } from "src/flow/modals/VersionPickerDisplay";
import { DetailHeader } from "src/layout/DetailHeader";
import { useAuthoringContext } from "src/router/routerContextHooks";
import { LeftPaneOptions } from "src/router/SearchParams";
import { getUrlToAuthoringPage } from "src/router/urls";
import { useSimulationDatasetBySimulationId } from "src/simulations/useSimulationDatasetBySimulationId";

type Props = {
  children?: React.ReactNode;
  border?: boolean;
};

type HeaderType = React.FC<Props>;

export const SimulationHeader: HeaderType = ({ children }) => {
  const {
    workspace,
    flow,
    version,
    orgId,
    simulationId = "",
  } = useAuthoringContext();
  const simulationDataset = useSimulationDatasetBySimulationId(simulationId);
  const simulationDatasetName = simulationDataset?.name ?? "Unkown Dataset";

  return (
    <div className="border border-gray-200" data-loc="simulation-header">
      <DetailHeader
        actions={<div data-loc="simulation-header-right">{children}</div>}
        main={
          <div
            className="flex items-center gap-x-3"
            data-loc="simulation-header-left"
          >
            <Link
              data-loc="go-back"
              to={getUrlToAuthoringPage(
                orgId,
                workspace.id,
                flow.id,
                version.id,
                { leftPane: LeftPaneOptions.Simulations },
              )}
            >
              <Icon icon={faArrowLeft} size="xs" />
            </Link>
            <span className="font-inter-semibold-13px text-gray-800">
              Simulation
            </span>
            <div data-loc="version-picker-display">
              <VersionPickerDisplay
                duplicateVersion={version}
                selected={false}
              />
            </div>
            <Pill size="sm" variant="gray">
              <Pill.Text>
                <span className="mr-1 flex" data-loc="simulation-dataset-name">
                  <Icon icon={faWavePulse} size="xs" />
                  {simulationDatasetName}
                </span>
              </Pill.Text>
            </Pill>
          </div>
        }
      />
    </div>
  );
};
